import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

// Строка-карточка с рамкой, как в макете: пункты панели читаются как отдельные объекты,
// а не как элементы выпадающего списка — от него мы как раз и уходили.
export const Row = styled.button`
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 14px 16px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-family: inherit;
    text-align: left;
    cursor: pointer;

    &:hover:not(:disabled) {
        border-color: ${colors.fieldBorder};
        background: rgba(0, 0, 0, 0.02);
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const RowIcon = styled.span`
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${radii.base};
    background: rgba(25, 118, 210, 0.08);
    color: ${colors.primary};

    svg {
        font-size: 20px;
    }
`;

export const RowText = styled.span`
    flex: 1;
    min-width: 0;
`;

export const RowTitle = styled.span`
    display: block;
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

// Подпись есть у каждой строки намеренно: пункт без объяснения результата — главная
// претензия к прежним двум безымянным выпадающим меню в шапке.
export const RowHint = styled.span`
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const RowChevron = styled.span`
    flex: none;
    display: flex;
    color: rgba(0, 0, 0, 0.38);
`;
